module.exports = __webpack_public_path__ + "static/media/Britain.efb611c3.jpg";